// Author thq
// Date 2021-10-24 21:49:50

class EmAclUserType {
constructor({
        id = null,
        sid = '',
        parentNcid = '',
        pkGroup = '',
        pkOrg = '',
        code = '',
        name = '',
        parentId = '',
        level = '',
        nodeCode = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.sid = sid;
    this.parentNcid = parentNcid;
    this.pkGroup = pkGroup;
    this.pkOrg = pkOrg;
    this.code = code;
    this.name = name;
    this.parentId = parentId;
    this.level = level;
    this.nodeCode = nodeCode;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new EmAclUserType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.emAclUserType.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sid',
        label: 'label.em.admin.emAclUserType.grid.sid',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentNcid',
        label: 'label.em.admin.emAclUserType.grid.parentNcid',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pkGroup',
        label: 'label.em.admin.emAclUserType.grid.pkGroup',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pkOrg',
        label: 'label.em.admin.emAclUserType.grid.pkOrg',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.admin.emAclUserType.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.admin.emAclUserType.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentId',
        label: 'label.em.admin.emAclUserType.grid.parentId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.em.admin.emAclUserType.grid.level',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.em.admin.emAclUserType.grid.nodeCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.em.admin.emAclUserType.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAclUserType.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    sidFilter : '',
    parentNcidFilter : '',
    pkGroupFilter : '',
    pkOrgFilter : '',
    codeFilter : '',
    nameFilter : '',
    parentIdFilter : '',
    levelFilter : '',
    nodeCodeFilter : '',
    seqFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'sidFilter',
        label: 'label.em.admin.emAclUserType.filter.sid',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentNcidFilter',
        label: 'label.em.admin.emAclUserType.filter.parentNcid',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkGroupFilter',
        label: 'label.em.admin.emAclUserType.filter.pkGroup',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkOrgFilter',
        label: 'label.em.admin.emAclUserType.filter.pkOrg',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.admin.emAclUserType.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.admin.emAclUserType.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentIdFilter',
        label: 'label.em.admin.emAclUserType.filter.parentId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'levelFilter',
        label: 'label.em.admin.emAclUserType.filter.level',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nodeCodeFilter',
        label: 'label.em.admin.emAclUserType.filter.nodeCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seqFilter',
        label: 'label.em.admin.emAclUserType.filter.seq',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'sid',
        label: 'label.em.admin.emAclUserType.entity.sid',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentNcid',
        label: 'label.em.admin.emAclUserType.entity.parentNcid',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkGroup',
        label: 'label.em.admin.emAclUserType.entity.pkGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkOrg',
        label: 'label.em.admin.emAclUserType.entity.pkOrg',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'code',
        label: 'label.em.admin.emAclUserType.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.em.admin.emAclUserType.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentId',
        label: 'label.em.admin.emAclUserType.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'level',
        label: 'label.em.admin.emAclUserType.entity.level',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nodeCode',
        label: 'label.em.admin.emAclUserType.entity.nodeCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seq',
        label: 'label.em.admin.emAclUserType.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAclUserType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmAclUserType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
